import React from 'react';
import { PhoneIcon, MessageCircleIcon } from 'lucide-react';
export function StickyBottomBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#f97316] text-white py-3 px-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:hidden" data-id="element-152">
      <div className="flex gap-2" data-id="element-153">
        <a href="tel:0523552222" className="flex-1 bg-white text-[#f97316] py-3 rounded-lg font-bold text-center flex items-center justify-center gap-1.5 shadow-sm active:bg-gray-100 text-sm" data-id="element-154">
          <PhoneIcon className="w-4 h-4 flex-shrink-0" data-id="element-155" />
          <span data-id="element-156">052-355-2222</span>
        </a>
        <a href="tel:0545188888" className="flex-1 bg-white text-[#f97316] py-3 rounded-lg font-bold text-center flex items-center justify-center gap-1.5 shadow-sm active:bg-gray-100 text-sm" data-id="element-157">
          <PhoneIcon className="w-4 h-4 flex-shrink-0" data-id="element-158" />
          <span data-id="element-159">054-518-8888</span>
        </a>
      </div>
    </div>;
}